// extracted by mini-css-extract-plugin
export default {"metrics_pm":"MemorandumValues_metrics_pm__qhDmG","column_metrics":"MemorandumValues_column_metrics__Rf409"};